import IComponent from "components/commons/IComponent";
import ResultList from "./ResultList";
import ItemDetail from "./ItemDetail";
import GIDetailUI from "./GIDetailUi";
import React from "react";
import "./SearchResult.scoped.css";
let searchResultObject = null;
let isCustomSearch = undefined;
let searchType = undefined;
let lastResult = null;
let lastResultSearchInfo = null;
class SearchResult extends IComponent {
  static updateSearchResultObject(
    resultList,
    boolIsCustomSearch,
    strSearchType
  ) {
    console.debug(arguments);
    searchResultObject = resultList;
    isCustomSearch = boolIsCustomSearch;
    searchType = strSearchType;
    lastResult = null;
    lastResultSearchInfo = null;
  }
  constructor(props) {
    super(props);
    this.state = {
      resultItem: lastResult,
      resultSearchInfo: lastResultSearchInfo,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  async subpanelCallback(action, args) {
    switch (action) {
      case "showItemDetail":
        this.setState({
          resultItem: args[0],
          resultSearchInfo: args[1],
        });
        lastResult = args[0];
        lastResultSearchInfo = args[1];
        break;
      case "goBack":
        this.setState({
          resultItem: null,
          resultSearchInfo: null,
        });
        lastResult = null;
        lastResultSearchInfo = null;
        // this.props.reduxCallProxy(rememberViewingResultItem, null);
        break;
    }
  }
  render() {
    let { resultItem, resultSearchInfo } = this.state;
    return (
      <div className="SearchResultPanel">
        {searchResultObject && (
          <div
            className="SearchItemList"
            style={{ display: !resultItem ? "block" : "none" }}
          >
            <ResultList
              {...this.props}
              allResults={searchResultObject}
              isCustomSearch={isCustomSearch}
              searchType={searchType}
              onSubPanelCallback={(action, arg) =>
                this.subpanelCallback(action, arg)
              }
            />
          </div>
        )}
        <div className="SearchItemDetail">
          {resultItem &&
            function() {
              switch (resultSearchInfo.itemDetailType) {
                case "mms":
                  return (
                    <ItemDetail
                      {...this.props}
                      item={resultItem}
                      showBackButton={
                        searchResultObject[0]?.results.length > 1 ||
                        searchResultObject[0]?.isCustomSearch
                      }
                      onSubPanelCallback={(action, arg) =>
                        this.subpanelCallback(action, arg)
                      }
                    />
                  );
                case "gireport":
                  return (
                    <GIDetailUI
                      {...this.props}
                      item={resultItem}
                      showBackButton={
                        searchResultObject[0]?.results.length > 1 ||
                        searchResultObject[0]?.isCustomSearch
                      }
                      searchInfo={resultSearchInfo}
                      onSubPanelCallback={(action, arg) =>
                        this.subpanelCallback(action, arg)
                      }
                    />
                  );
                default:
                  <div />;
              }
            }.apply(this)}
        </div>
      </div>
    );
  }
}

export default SearchResult;
